/**
 * Halloween mode — when enabled, 1-in-10 song starts are replaced with a
 * misc track (client-side chance; server just tracks the toggle + exposes
 * the misc library).
 */
import { z } from "zod";
export const HalloweenStateSchema = z.object({
    enabled: z.boolean(),
});
export const PutHalloweenBodySchema = z.object({
    enabled: z.boolean(),
});
//# sourceMappingURL=halloween.js.map